import React from 'react';

import { telemetryConsumerWrapper } from '~src/commonInfra/telemetryEvents/contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '~src/commonInfra/telemetryEvents/contexts/TelemetryContexts';
import { ContentClickedEventHandler } from '~src/commonInfra/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '~src/commonInfra/telemetryEvents/util/EventHandlerFactories';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CommonDatabaseInfo } from '~src/spacesPlatform/models/CommonDatabaseInfo';

import { Messages } from '../../../codegen/Localize';

export type DatabaseThumbnailProps = Pick<React.AriaAttributes, 'aria-label'> & {
    readonly allowDragAndDrop: boolean;
    readonly content: CommonDatabaseInfo;
    readonly contentUrl?: string;
    readonly hoveredOrSelected?: boolean;
}
export class DatabaseThumbnail extends React.Component<DatabaseThumbnailProps> {
    public render() {
        const databaseContent = this.props.content as CommonDatabaseInfo;
        const containerClass = this.props.hoveredOrSelected ? CardViewStyles.CustomThumbnailHoverNoPointer : CardViewStyles.CustomThumbnail;

        const isDbServer: boolean = databaseContent.dbType === 'DatabaseServer';
        const imgUrl = isDbServer ?  imgPath('database_server_card.svg') : imgPath('file_card.svg');
        const thumbnailSecondTitle = isDbServer ? Messages.databaseCardHostname() + databaseContent.hostName : Messages.databaseCardFilepath() + databaseContent.filePath;
        /* eslint-disable jsx-a11y/alt-text */
        return (
            <div className={containerClass}>
                <div className={CardViewStyles.CustomThumbnailTopContainer}>
                    <div className={CardViewStyles.DatabaseCustomThumbnailImg}>
                        <img src={imgUrl}
                             width={'60px'} height={'60px'}
                             data-tb-test-id= 'database-icon' />
                    </div>
                    <div>{databaseContent.connectionType}</div>
                    <div className={CardViewStyles.DatabaseCustomSecondTitle}>{thumbnailSecondTitle}</div>
                </div>
                {this.props.contentUrl &&
                    telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
                        /* eslint-disable jsx-a11y/anchor-has-content */
                        <a
                            onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}
                            href={this.props.contentUrl}
                            className={CardViewStyles.AnchorUnderlay}
                            /**
                             * If card reordering allowed, disable link dragging.
                             * Otherwise, set `draggable` explicitly to undefined rather than true.
                             * (When `draggable` is true, the browser-provided drag avatar looks too similar
                             * to the reorder card feature's avatar, which may confuse users.)
                             */
                            draggable={this.props.allowDragAndDrop ? false : undefined}
                            aria-label={this.props['aria-label']}
                        ></a>
                    )
                }
            </div>
        );
    }
}